/* eslint-disable max-len */
/* eslint-disable react/no-unused-prop-types,no-console,
react/no-danger,react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import ContentLoader from 'react-content-loader';
import { formatRoute } from 'react-router-named-routes';
import { withTranslation } from 'react-i18next';
// material-ui icons
import Edit from '@material-ui/icons/Edit';
import FilterIco from '@material-ui/icons/FilterList';
import Refresh from '@material-ui/icons/Refresh';
import LinearProgress from '@material-ui/core/LinearProgress';
// material-ui/ core components
import extendedTablesStyle from 'assets/jss/material-dashboard-pro-react/views/extendedTablesStyle';
import { Hidden, Tooltip, Zoom } from '@material-ui/core';
import withStyles from '@material-ui/core/styles/withStyles';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import Button from 'components/UI/CustomButtons/Button';
import GridContainer from 'components/UI/Grid/GridContainer';
// our components
import { NOTIFICATION_CATEGORY } from 'routes/paths';
import RouterContext from 'helpers/routerContext';
import Paginator from 'components/common/Paginator';
import { TableLoader } from 'components/common/TableLoader';
import Filter from 'components/NotificationCategory/Filter';
import WithPermission from 'components/User/WithPermission';

/**
 * @description - NotificationCategoryList component
 * @augments React.Component
 */
class NotificationCategoryList extends React.Component {
  static contextType = RouterContext;

  constructor(props) {
    super(props);
    this.state = {
      showFilters: false,
    };
  }

  /**
   * @description
   * Handle show collapsed or full filters.
   */
  handleShowFilters = () => {
    const { showFilters } = this.state;
    this.setState({ showFilters: !showFilters });
  };

  /**
   * @description
   * Redirect to notification_category/create route.
   */
  handleCreate = () => {
    const history = this.context;
    history.push(NOTIFICATION_CATEGORY.CREATE);
  };

  /**
   * @description
   * Redirect to notification_category/update route.
   *
   * @param {string} id - Id of the notification category to edit.
   */
  handleEdit = id => {
    const history = this.context;
    history.push(formatRoute(NOTIFICATION_CATEGORY.UPDATE, { id }));
  };

  /**
   * @description
   * Call refresh callback.
   */
  handleRefresh = () => {
    const { refresh } = this.props;
    refresh();
  };

  /**
   * @description
   * Render component.
   *
   * @returns {*} Component to render.
   */
  render() {
    const {
      classes,
      t,
      data,
      loading,
      fullLoading,
      changeNumberOfRows,
      changePage,
      numberOfRowsSelected,
      paginationDirection,
      appliedFilter,
      filter,
    } = this.props;
    const { showFilters } = this.state;

    const edges =
      loading || data === undefined
        ? []
        : data.adminNotificationCategories.edges;

    return (
      <GridContainer>
        <GridItem xs={12}>
          <div className={classes.pageContainer}>
            <GridContainer justify="space-between" alignItems="center">
              <GridItem>
                <h3 className={classes.title}>
                  {t('common.sidemenu.notification_categories')}
                </h3>
              </GridItem>

              <GridItem>
                <Button
                  color="primary"
                  simple
                  onClick={this.handleRefresh}
                  id="refresh"
                  key="refresh"
                >
                  <Refresh />
                  {t('ad.filters.update')}
                </Button>
                <WithPermission allowPermissions={['add_notificationcategory']}>
                  <Button
                    data-cy="createNotificationCategory"
                    color="success"
                    default
                    onClick={() => this.handleCreate()}
                    id="createNotificationCategory"
                    style={{ marginLeft: 16 }}
                  >
                    {t('notificationCategory.create')}
                  </Button>
                </WithPermission>
              </GridItem>
            </GridContainer>

            <GridContainer>
              <GridItem xs={12}>
                <div className={classes.contentContainer}>
                  <div
                    className={[
                      classes.loadingLineContainer,
                      classes.topLine,
                    ].join(' ')}
                  >
                    {' '}
                    {fullLoading && (
                      <LinearProgress
                        classes={{
                          barColorPrimary: classes.loadingLine,
                        }}
                      />
                    )}
                  </div>
                  <GridContainer
                    justify="space-between"
                    alignItems="center"
                    className={classes.loteActionsAnimation}
                  >
                    <GridItem xs={12} sm={8} md={7}>
                      <div className={classes.searchFieldContainer}>
                        <Button
                          color="info"
                          round
                          simple={!showFilters}
                          onClick={this.handleShowFilters}
                          id="filter"
                          key="filter"
                          data-cy="filterBtn"
                        >
                          <FilterIco />
                          <span>{t('user.list.filter')}</span>
                        </Button>
                      </div>
                      <Hidden
                        only={['sm', 'md', 'lg', 'xl']}
                        implementation="css"
                      >
                        <GridContainer>
                          <GridItem xs={12}>
                            <div
                              className={`${classes.loteActionsAnimation}
                    ${
                      showFilters
                        ? classes.showPaidAdFilters
                        : classes.hideFilters
                    }`}
                            >
                              <Filter
                                filter={filter}
                                appliedFilter={appliedFilter}
                              />
                            </div>
                          </GridItem>
                        </GridContainer>
                      </Hidden>
                    </GridItem>
                    <GridItem xs={12} sm={4} md={5}>
                      {!fullLoading ? (
                        <Paginator
                          pageInfo={data.adminNotificationCategories.pageInfo}
                          changePage={changePage}
                          changeNumberOfRows={changeNumberOfRows}
                          paginationDirection={paginationDirection}
                          numberOfRowsSelected={numberOfRowsSelected}
                        />
                      ) : (
                        <ContentLoader height={67} width={327} speed={2}>
                          <path
                            // eslint-disable-next-line max-len
                            d="M199,16 L304,16 C307.313708,16 310,18.6862915 310,22 L310,46 C310,49.3137085 307.313708,52 304,52 L199,52 C195.686292,52 193,49.3137085 193,46 L193,22 C193,18.6862915 195.686292,16 199,16 Z M25.9861352,27.0121317 L70.0138648,27.0121317 C74.4244855,27.0121317 78,30.5876462 78,34.9982669 C78,39.4088876 74.4244855,42.9844021 70.0138648,42.9844021 L25.9861352,42.9844021 C21.5755145,42.9844021 18,39.4088876 18,34.9982669 C18,30.5876462 21.5755145,27.0121317 25.9861352,27.0121317 Z M103.986135,27.0121317 L148.013865,27.0121317 C152.424485,27.0121317 156,30.5876462 156,34.9982669 C156,39.4088876 152.424485,42.9844021 148.013865,42.9844021 L103.986135,42.9844021 C99.5755145,42.9844021 96,39.4088876 96,34.9982669 C96,30.5876462 99.5755145,27.0121317 103.986135,27.0121317 Z"
                            fill="#D8D8D8"
                          />
                        </ContentLoader>
                      )}
                    </GridItem>
                  </GridContainer>
                  <Hidden only={['xs']} implementation="css">
                    <GridContainer>
                      <GridItem xs={12}>
                        <div
                          className={`${classes.loteActionsAnimation}
                    ${
                      showFilters
                        ? classes.showPaidAdFilters
                        : classes.hideFilters
                    }`}
                        >
                          <Filter
                            filter={filter}
                            appliedFilter={appliedFilter}
                          />
                        </div>
                      </GridItem>
                    </GridContainer>
                  </Hidden>
                  <GridContainer>
                    <GridItem xs={12}>
                      {loading ? (
                        <TableLoader />
                      ) : (
                        <ReactTable
                          data={edges}
                          loading={loading}
                          columns={[
                            {
                              Header: t('notificationCategory.id'),
                              accessor: 'node.id',
                              minWidth: 100,
                            },
                            {
                              Header: t('notificationCategory.name'),
                              accessor: 'node.name',
                              minWidth: 150,
                            },
                            {
                              Header: t('notificationCategory.order'),
                              accessor: 'node.order',
                              minWidth: 100,
                            },
                            {
                              Header: t('notificationCategory.description'),
                              accessor: 'node.description',
                              minWidth: 200,
                            },
                            {
                              Header: t('common.actions'),
                              accessor: 'actions',
                              sortable: false,
                              filterable: false,
                              minWidth: 100,
                              Cell: row => (
                                <div className="actions-right">
                                  <WithPermission
                                    allowPermissions={[
                                      'change_notificationcategory',
                                    ]}
                                  >
                                    <Tooltip
                                      placement="top"
                                      TransitionComponent={Zoom}
                                      title={
                                        <React.Fragment>
                                          {t('common.edit')}
                                          <span className={classes.arrow} />
                                        </React.Fragment>
                                      }
                                      classes={{
                                        tooltip: classes.bootstrapTooltip,
                                        tooltipPlacementTop:
                                          classes.bootstrapPlacementTop,
                                      }}
                                    >
                                      <Button
                                        data-cy="notificationCategoryUpdate"
                                        justIcon
                                        simple
                                        onClick={() =>
                                          this.handleEdit(row.original.node.id)
                                        }
                                        color="primary"
                                        className="edit"
                                        id={`edit-notification-category-${row.original.node.id}`}
                                      >
                                        <Edit />
                                      </Button>
                                    </Tooltip>
                                  </WithPermission>
                                </div>
                              ),
                            },
                          ]}
                          pageSize={edges.length}
                          showPagination={false}
                          className={['-striped -highlight', classes.tbl].join(
                            ' ',
                          )}
                        />
                      )}
                    </GridItem>
                  </GridContainer>
                </div>
              </GridItem>
            </GridContainer>
          </div>
        </GridItem>
      </GridContainer>
    );
  }
}

/**
 * NotificationCategoryList PropTypes
 */
NotificationCategoryList.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  t: PropTypes.func.isRequired,
  data: PropTypes.shape({
    adminNotificationCategories: PropTypes.shape({
      edges: PropTypes.arrayOf(
        PropTypes.shape({
          node: PropTypes.shape({
            id: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
            order: PropTypes.number.isRequired,
          }),
        }),
      ),
      pageInfo: PropTypes.instanceOf(Object),
    }),
  }),
  loading: PropTypes.bool,
  fullLoading: PropTypes.bool,
  changeNumberOfRows: PropTypes.func.isRequired,
  changePage: PropTypes.func.isRequired,
  numberOfRowsSelected: PropTypes.number.isRequired,
  paginationDirection: PropTypes.string,
  appliedFilter: PropTypes.instanceOf(Object),
  filter: PropTypes.func.isRequired,
  refresh: PropTypes.func.isRequired,
};

NotificationCategoryList.defaultProps = {
  data: { adminNotificationCategories: { edges: [], pageInfo: null } },
  loading: false,
  fullLoading: false,
  appliedFilter: null,
  paginationDirection: null,
};

export default withTranslation()(
  withStyles(extendedTablesStyle)(NotificationCategoryList),
);
